import React, { useContext } from "react";
import Constant from "../../Constants";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import { ReactComponent as FavIcon } from "../../../images/favourite-icon.svg";
import ThemeContext from "../../../utils/Contexts/ThemeContext";

function OfferCard({ offer }) {
  const { t } = useContext(LanguageContext);
  const { categoryOptions, themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);
  return (
    <div
      className={`pt-1 p-3 d-flex align-items-center gap-3 ${themeStatus?.[selectedTheme]}`}
      style={{
        borderBottom: "2px solid var(--border)",
        marginBottom: "12px",
      }}
    >
      <FavIcon />
      <div>
        <p
          className="card-text p-0 m-0"
          style={{ color: "var(--whiteToBlack)" }}
        >
          {offer?.domain}
          <i
            className="bi-person-check text-muted ms-1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Verified Owner"
          />
        </p>
        <p className="p-0 m-0 mt-2">
          {offer?.summary?.categories?.length ? (
            <>
              {offer.summary.categories.slice(0, 3).map((category, i) => (
                <span
                  key={i}
                  className="badge bg-soft-secondary text-secondary me-1"
                >
                  {categoryOptions[category]}
                </span>
              ))}
              {offer.summary.categories.length > 3 && (
                <span className="badge bg-soft-secondary text-secondary">
                  + {offer.summary.categories.length - 3} {t("more")}
                </span>
              )}
            </>
          ) : (
            <span className="badge bg-soft-secondary text-secondary">
              {t("Any Category")}
            </span>
          )}
        </p>
      </div>
    </div>
  );
}

export default OfferCard;
